// Charter-hue palette — deterministic mapping from charter_id → colour so
// the same trip keeps the same accent across every render and cabin card.
// Tailwind purges unused class names, so every class we might return has to
// appear here as a plain-text literal (no dynamic template strings).

const HUES = [
  {
    id: "amber",
    label: "Amber",
    borderLeft: "border-l-amber-500",
    ring: "ring-amber-500/50",
    chipBg: "bg-amber-500/10",
    chipText: "text-amber-700 dark:text-amber-400",
    berthOccupied: "bg-amber-500/15 border-amber-500/50",
    dot: "bg-amber-500",
  },
  {
    id: "emerald",
    label: "Emerald",
    borderLeft: "border-l-emerald-500",
    ring: "ring-emerald-500/50",
    chipBg: "bg-emerald-500/10",
    chipText: "text-emerald-700 dark:text-emerald-400",
    berthOccupied: "bg-emerald-500/15 border-emerald-500/50",
    dot: "bg-emerald-500",
  },
  {
    id: "sky",
    label: "Sky",
    borderLeft: "border-l-sky-500",
    ring: "ring-sky-500/50",
    chipBg: "bg-sky-500/10",
    chipText: "text-sky-700 dark:text-sky-400",
    berthOccupied: "bg-sky-500/15 border-sky-500/50",
    dot: "bg-sky-500",
  },
  {
    id: "rose",
    label: "Rose",
    borderLeft: "border-l-rose-500",
    ring: "ring-rose-500/50",
    chipBg: "bg-rose-500/10",
    chipText: "text-rose-700 dark:text-rose-400",
    berthOccupied: "bg-rose-500/15 border-rose-500/50",
    dot: "bg-rose-500",
  },
  {
    id: "violet",
    label: "Violet",
    borderLeft: "border-l-violet-500",
    ring: "ring-violet-500/50",
    chipBg: "bg-violet-500/10",
    chipText: "text-violet-700 dark:text-violet-400",
    berthOccupied: "bg-violet-500/15 border-violet-500/50",
    dot: "bg-violet-500",
  },
  {
    id: "teal",
    label: "Teal",
    borderLeft: "border-l-teal-500",
    ring: "ring-teal-500/50",
    chipBg: "bg-teal-500/10",
    chipText: "text-teal-700 dark:text-teal-400",
    berthOccupied: "bg-teal-500/15 border-teal-500/50",
    dot: "bg-teal-500",
  },
  {
    id: "orange",
    label: "Orange",
    borderLeft: "border-l-orange-500",
    ring: "ring-orange-500/50",
    chipBg: "bg-orange-500/10",
    chipText: "text-orange-700 dark:text-orange-400",
    berthOccupied: "bg-orange-500/15 border-orange-500/50",
    dot: "bg-orange-500",
  },
  {
    id: "indigo",
    label: "Indigo",
    borderLeft: "border-l-indigo-500",
    ring: "ring-indigo-500/50",
    chipBg: "bg-indigo-500/10",
    chipText: "text-indigo-700 dark:text-indigo-400",
    berthOccupied: "bg-indigo-500/15 border-indigo-500/50",
    dot: "bg-indigo-500",
  },
];

// Neutral hue for cabins with no active charter — used so vacant cards
// still have a consistent visual language (thin muted left rail vs. the
// bold charter rail).
export const NEUTRAL_HUE = {
  id: "neutral",
  label: "Vacant",
  borderLeft: "border-l-transparent",
  ring: "ring-border",
  chipBg: "bg-muted",
  chipText: "text-muted-foreground",
  berthOccupied: "bg-muted/40 border-border/60",
  dot: "bg-border",
};

// Small djb2-style hash so a charter's colour never changes between renders
// and is stable across sessions (unlike Math.random()).
function hash(s) {
  let h = 5381;
  const str = String(s || "");
  for (let i = 0; i < str.length; i++) {
    h = ((h << 5) + h) + str.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

export function hueForCharter(charterId) {
  if (!charterId) return NEUTRAL_HUE;
  return HUES[hash(charterId) % HUES.length];
}
